export const CERTIFICATIONS_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/#organization",
   "name": "Everest Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png"
   },
   "sameAs": [
    "https://www.facebook.com/everestoficialbr",
    "https://www.instagram.com/everestoficial_"
   ]
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "inLanguage": "pt-BR"
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/certificacoes#webpage",
   "url": "https://everest.ind.br/pt/certificacoes",
   "name": "Certificações dos Purificadores Everest | Normas e Selos de Qualidade",
   "description": "A Everest é a maior marca de purificadores de água do Brasil, cumprindo as determinações e recebendo as principais certificações do mercado para trazer segurança.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/certificacoes#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/certificacoes#certifications"
   },
   "dateModified": "2026-04-16"
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/certificacoes#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Certificações",
     "item": "https://everest.ind.br/pt/certificacoes"
    }
   ]
  },
  {
   "@type": "ItemList",
   "@id": "https://everest.ind.br/pt/certificacoes#certifications",
   "name": "Certificações dos Purificadores Everest",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "ABRAFIPA"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Bauer"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Bauer Refil"
    }
   ]
  }
 ]
}
